<template>
    <div>
        <div class="font-small-2 text-muted" v-if="caption">{{ caption }}</div>
        <div class="report-summary-bar py-1 font-weight-bold" v-if="visible">
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportSummaryBar',
    data() {
        return {
            visible: false,
            title: '',
            caption: '',
        }
    },
    methods: {
        setVisible(visible) {
            this.visible = visible;
        },
        setTitle(title) {
            this.title = title;
        },
        setCaption(caption) {
            this.caption = caption;
        },
        isVisible() {
            return this.visible;
        }
    }
}
</script>